import { c as classNames } from '../../shared/bind-56cf2a3b.js';
import { getTestId } from '../../utils/testId.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "label": "web_ui__Label__label",
  "content": "web_ui__Label__content",
  "suffix": "web_ui__Label__suffix",
  "default": "web_ui__Label__default",
  "narrow": "web_ui__Label__narrow",
  "wide": "web_ui__Label__wide",
  "leading": "web_ui__Label__leading",
  "stacked": "web_ui__Label__stacked"
};

var Type = /*#__PURE__*/function (Type) {
  Type["Stacked"] = "stacked";
  Type["Leading"] = "leading";
  return Type;
}(Type || {});
var Styling = /*#__PURE__*/function (Styling) {
  Styling["Default"] = "default";
  Styling["Narrow"] = "narrow";
  Styling["Wide"] = "wide";
  return Styling;
}(Styling || {});
var cssClasses = classNames.bind(styles);
var Label = function Label(_ref) {
  var text = _ref.text,
    _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? Styling.Default : _ref$styling,
    type = _ref.type,
    suffix = _ref.suffix,
    testId = _ref.testId;
  var labelClass = cssClasses('label', styling, type);
  return /*#__PURE__*/jsxs("div", {
    className: labelClass,
    "data-testid": testId,
    children: [/*#__PURE__*/jsx("div", {
      className: styles.content,
      "data-testid": getTestId(testId, 'text'),
      children: text
    }), suffix ? /*#__PURE__*/jsx("div", {
      className: styles.suffix,
      "data-testid": getTestId(testId, 'suffix'),
      children: suffix
    }) : null]
  });
};
Label.Styling = Styling;
Label.Type = Type;

export { Label as default };
//# sourceMappingURL=Label.js.map
